import styled from 'styled-components';

const ListItem = styled.li`
  display: block;
`;

export default ListItem;
